import React, { FC, useMemo } from 'react'
import { Box } from '@material-ui/core'
import { useLocation } from 'react-router-dom'

import { Routes } from '@root-gipro/router'
import { usePageLink } from '@root-gipro/shared/hooks/usePageLink'
import { TypesNavLink } from '@root-gipro/shared/TabsComponents/tabs.props'
import { TabsNavLink } from '@root-gipro/shared/TabsComponents/TabsNavLink'

const TabsCheckPlate: FC = () => {
	const { pathname } = useLocation()
	const { pathRoute } = usePageLink()

	const urlId = useMemo(() => pathname.replace(/[^\d]/g, ''), [pathname])

	const routes: any = useMemo(
		() => ({
			parameters: {
				[Routes.COMMON_PROJECTS]: Routes.COMMON_PROJECTS_PARAMETERS.replace(/:id/, urlId),
				[Routes.USER_PROJECTS]: Routes.USER_PROJECTS_PARAMETERS.replace(/:id/, urlId),
				[Routes.USER_ARCHIVE]: Routes.USER_ARCHIVE_PARAMETERS.replace(/:id/, urlId),
			},
			rates: {
				[Routes.COMMON_PROJECTS]: Routes.COMMON_PROJECTS_RATES.replace(/:id/, urlId),
				[Routes.USER_PROJECTS]: Routes.USER_PROJECTS_RATES.replace(/:id/, urlId),
				[Routes.USER_ARCHIVE]: Routes.USER_ARCHIVE_RATES.replace(/:id/, urlId),
			},
			tech: {
				[Routes.COMMON_PROJECTS]: Routes.COMMON_PROJECTS_TECHNICAL_SOLUTIONS.replace(/:id/, urlId),
				[Routes.USER_PROJECTS]: Routes.USER_PROJECTS_TECHNICAL_SOLUTIONS.replace(/:id/, urlId),
				[Routes.USER_ARCHIVE]: Routes.USER_ARCHIVE_TECHNICAL_SOLUTIONS.replace(/:id/, urlId),
			},
			rpc: {
        [Routes.COMMON_PROJECTS]: Routes.USER_PROJECTS_RPC.replace(/:id/, urlId),
        [Routes.USER_PROJECTS]: Routes.USER_PROJECTS_RPC.replace(/:id/, urlId),
        [Routes.USER_ARCHIVE]: Routes.USER_PROJECTS_RPC.replace(/:id/, urlId),
			},
		}),
		[urlId]
	)

	const typesRoute: TypesNavLink[] = useMemo(() => {
    return [
			{
				title: 'Параметры',
				path: routes.parameters[pathRoute],
				tags: [Routes.COMMON_PROJECTS, Routes.USER_PROJECTS, Routes.USER_ARCHIVE],
			},
			{
				title: 'Расценки',
				path: routes.rates[pathRoute],
				tags: [Routes.COMMON_PROJECTS, Routes.USER_PROJECTS, Routes.USER_ARCHIVE],
			},
			{
				title: 'Технические решения',
				path: routes.tech[pathRoute],
				tags: [Routes.COMMON_PROJECTS, Routes.USER_PROJECTS, Routes.USER_ARCHIVE],
			},
			{
				title: 'РПС',
				path: routes.rpc[pathRoute],
				tags: [Routes.COMMON_PROJECTS, Routes.USER_PROJECTS, Routes.USER_ARCHIVE],
			},
		]
	}, [routes, pathRoute])

	return (
		<div className='breadcrumbs-wrapper'>
			<Box className='flex' style={{ gap: 16 }}>
				<TabsNavLink types={typesRoute} path={pathRoute} />
			</Box>
		</div>
	)
}

export default TabsCheckPlate
